// ponytail: hardcoded beta allowlist, UI only (the API still answers other orgs).
// Remove it, or move it to the plan's feature list, when Expenses leaves beta.
const EXPENSES_BETA_ORG_IDS = [
  'ec889412-badb-4c6e-9d6b-6b887235d456',
  '9252aa06-8da8-46aa-a731-a57ae29386d1',
];

/** Company expenses (Expenses tab, Settings → Expense Categories) are in beta for these orgs only. */
export function isExpensesBetaOrg(orgId: string | null | undefined): boolean {
  return !!orgId && EXPENSES_BETA_ORG_IDS.includes(orgId.toLowerCase());
}
